import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    email,
} from 'react-admin';

export const validateEmail = [required(), email()];
export const validateRequired = [required()];

export const inputStyle = { width: '20em' }

const ReferralCreate = ({ permissions, ...props }) => {
    const commonInputProps = {
        style: inputStyle,
    };

    const validateReferralCreation = (values) => {
        const errors = {};
        
        // 验证邮箱格式
        if (values.referee_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.referee_email)) {
            errors.referee_email = 'Please enter a valid email address';
        }
        
        return errors;
    };

    return (
        <Create title="Create Referral" {...props}>
            <SimpleForm redirect="list" validate={validateReferralCreation}>
                <TextInput 
                    source="referee_email" 
                    label="Referee Email" 
                    validate={validateEmail} 
                    {...commonInputProps}
                    helperText="Enter the email address of the person you want to refer"
                />
            </SimpleForm>
        </Create>
    );
};

export default ReferralCreate;